// Sri Lanka Private Limited company registration packages (LKR).
// Single source of truth for the pricing widget and the page's Offer schema.

export const CURRENCY = 'LKR'

export const PACKAGES = [
  {
    id: 'start',
    icon: '💳',
    name: 'Start',
    price: 34900,
    tagline: 'For founders who only need the registration itself — for a tender or a loan application.',
    popular: false,
    features: [
      'Company name approval (3 options)',
      'Articles of Association',
      'Form 1, Form 18, Form 19',
      'ROC Certified Form 1',
      'BO Registration (Gazette 2480/48)',
      'Incorporation Certificate — printed + digital',
      'Online Client Portal',
      'WhatsApp support',
      'Free incorporation advice',
    ],
    excluded: [
      'TIN Certificate',
      'Director Seal',
      'Bank account document set',
      'Certified copies',
    ],
    cta: 'Choose Start',
  },
  {
    id: 'business-ready',
    icon: '⭐',
    badge: '⭐ Most popular',
    name: 'Business Ready',
    price: 45970,
    tagline: 'For founders who want to actually start trading — bank account and tax file included.',
    popular: true,
    inheritsFrom: 'Start',
    features: [
      '⚡ Priority Processing',
      'TIN Certificate (tax registration)',
      'Director Seal (pre-inked)',
      'Certified Articles of Association',
      'Certified Copy of Incorporation Certificate',
      'Corporate bank account — full document set',
      'Board Resolution for bank account',
      'Online banking registration documents',
      'Share Certificates',
    ],
    excluded: [],
    footnote: '💡 Bought separately these add up to Rs. 14,000 — here you pay only Rs. 11,070.',
    cta: 'Choose Business Ready',
  },
  {
    id: 'go-global',
    icon: '🌍',
    badge: '🇺🇸 Includes USA LLC',
    name: 'Go Global',
    price: 98800,
    tagline: 'For freelancers, agencies and exporters who get paid in dollars.',
    popular: false,
    inheritsFrom: 'Business Ready',
    features: [
      '🇺🇸 USA LLC company registration',
      'EIN number (US tax ID)',
      'Registered Agent — one year',
      'US business bank / EMI account setup support',
      'Stripe · Wise · Payoneer onboarding support',
      'Payment gateway integration guidance',
      'Business domain + 5 professional emails',
      'Cross-border invoicing setup',
    ],
    excluded: [],
    cta: 'Choose Go Global',
  },
]

export const formatLKR = (amount) => `Rs. ${amount.toLocaleString('en-LK')}`
